import React from 'react';
import {isEmpty} from 'lodash/lang';
import {Col, Row} from 'reactstrap';

class PublicStandards extends React.Component {
  render() {
    const {scopes} = this.props;

    let main = [];
    let sub4 = [];
    let sub5 = [];

    scopes.forEach((item) => {
      if (item.scope_type === 'Main') main.push(item);
      if (item.scope_type === 'Sub') {
        if (item.level === 'Level 4') sub4.push(item);
        if (item.level === 'Level 5') sub5.push(item);
      }
    });

    return (
      <React.Fragment>
        {!isEmpty(main) && (
          <Row>
            <Col sm="12" lg="4">
              <h4 className="mb-1">Main Scopes</h4>
            </Col>

            <Col sm="12" lg="8">
              <ul className="mb-5 list-style-disc">
                {main.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.document_type}: {item.standards_code} -{' '}
                      {item.scope_date}
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        )}

        {(!isEmpty(sub4) || !isEmpty(sub5)) && (
          <Row>
            <Col sm="12" lg="4">
              <h4 className="mb-1">Sub Scopes</h4>
            </Col>

            <Col sm="12" lg="8">
              <ul>
                {!isEmpty(sub4) && (
                  <li>
                    <h5>Level 4</h5>

                    <ul className="mb-3 list-style-disc">
                      {sub4.map((item, index) => {
                        return (
                          <li key={index}>
                            {item.document_type}: {item.standards_code} -{' '}
                            {item.scope_date}
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                )}

                {!isEmpty(sub5) && (
                  <li>
                    <h5>Level 5</h5>
                    <ul className="list-style-disc">
                      {sub5.map((item, index) => {
                        return (
                          <li key={index}>
                            {item.document_type}: {item.standards_code} -{' '}
                            {item.scope_date}
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                )}
              </ul>
            </Col>
          </Row>
        )}
      </React.Fragment>
    );
  }
}

export default PublicStandards;
